/* eslint-disable */
// This is auto generated code, do not edit directly
// @ts-ignore
import * as Types from '../../../../core/graphql/generated/types';

import { gql } from '@apollo/client';
import {
	HcpSearchAndFiltersFragmentDoc,
	HcoSearchAndFiltersFragmentDoc,
	BadRequestFragmentDoc
} from '../../../../core/fragments/core.hook';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateSearchHistoryMutationVariables = Types.Exact<{
	searchData: Types.RecentSearchInput;
}>;

export type UpdateSearchHistoryMutation = {
	__typename?: 'Mutation';
	updateRecentSearches:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| {
				__typename?: 'RecentSearch';
				searchKey: string;
				entityType: Types.EntityType;
				lastSearch: any;
				payload:
					| {
							__typename?: 'HCOSearchAndFiltersType';
							searchString?: string | null;
							countries?: Array<string> | null;
							states?: Array<string> | null;
							hcoTypes?: Array<string> | null;
							includeInactive: boolean;
					  }
					| {
							__typename?: 'HCPSearchAndFiltersType';
							searchString?: string | null;
							countries?: Array<string> | null;
							states?: Array<string> | null;
							specialtyGroups?: Array<string> | null;
							specialties?: Array<string> | null;
							hcpTypes?: Array<string> | null;
							hcos?: Array<string> | null;
							includeInactive: boolean;
					  };
		  };
};

export const UpdateSearchHistoryDocument = gql`
	mutation UpdateSearchHistory($searchData: RecentSearchInput!) {
		updateRecentSearches(searchData: $searchData) {
			... on RecentSearch {
				searchKey
				entityType
				lastSearch
				payload {
					...HCPSearchAndFilters
					...HCOSearchAndFilters
				}
			}
			...BadRequest
		}
	}
	${HcpSearchAndFiltersFragmentDoc}
	${HcoSearchAndFiltersFragmentDoc}
	${BadRequestFragmentDoc}
`;
export type UpdateSearchHistoryMutationFn = Apollo.MutationFunction<
	UpdateSearchHistoryMutation,
	UpdateSearchHistoryMutationVariables
>;

/**
 * __useUpdateSearchHistoryMutation__
 *
 * To run a mutation, you first call `useUpdateSearchHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSearchHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSearchHistoryMutation, { data, loading, error }] = useUpdateSearchHistoryMutation({
 *   variables: {
 *      searchData: // value for 'searchData'
 *   },
 * });
 */
export function useUpdateSearchHistoryMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateSearchHistoryMutation,
		UpdateSearchHistoryMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateSearchHistoryMutation,
		UpdateSearchHistoryMutationVariables
	>(UpdateSearchHistoryDocument, options);
}
export type UpdateSearchHistoryMutationHookResult = ReturnType<
	typeof useUpdateSearchHistoryMutation
>;
export type UpdateSearchHistoryMutationResult =
	Apollo.MutationResult<UpdateSearchHistoryMutation>;
export type UpdateSearchHistoryMutationOptions = Apollo.BaseMutationOptions<
	UpdateSearchHistoryMutation,
	UpdateSearchHistoryMutationVariables
>;
